/* Подписи интерфейса, русский. Правится руками.
 *
 * Строки взяты из исходной русской версии (коммит 2970a6f), а не переведены
 * заново с английского: это оригинал, а не обратный перевод.
 * Часть подписей в разделах «модули», «прогресс» и «профиль» переведена с «вы»
 * на «ты» — в остальном каталоге и у Алисы обращение на «ты».
 */

export const ui_ru = {
  // общее, встречается на нескольких экранах
  'ui.common.loading': 'Загрузка...',
  'ui.common.continue': 'Продолжить',
  'ui.common.check': 'Проверить',
  'ui.common.seeResults': 'Посмотреть результаты',
  'ui.common.myProgress': 'Мой прогресс',
  'ui.common.startTraining': 'Начать обучение',
  'ui.common.min': 'мин',

  // инструктор
  'ui.alisa.name': 'Алиса',
  'ui.alisa.initial': 'А',

  // нижняя навигация
  'ui.nav.home': 'Главная',
  'ui.nav.modules': 'Модули',
  'ui.nav.progress': 'Прогресс',
  'ui.nav.profile': 'Профиль',

  // заставка и знакомство
  'ui.splash.tagline': 'Первый день на линии',
  'ui.splash.cardTitle': 'Интерактивный тренажёр',
  'ui.splash.cardText':
    'Пройди обучение с виртуальным инструктором Алисой. Отработай реальные ситуации в безопасной среде и подготовься к первому дню на работе. Это займёт всего около 5 минут!',
  'ui.splash.start': 'Начать',
  'ui.splash.imAlisa': 'Я Алиса',
  'ui.splash.yourName': 'Как тебя зовут?',
  'ui.splash.introducePrompt': 'Представься, чтобы мы могли начать обучение',
  'ui.splash.namePlaceholder': 'Введи своё имя',

  // главный экран
  'ui.home.badgeLine1': 'Первый день',
  'ui.home.badgeLine2': 'на линии',
  'ui.home.welcome': 'Добро пожаловать,',
  'ui.home.ctaContinue': 'Продолжить обучение',
  'ui.home.ctaRetake': 'Повторить обучение',
  'ui.home.ctaStart': 'Начать обучение',
  'ui.home.settings': 'Настройки',
  'ui.home.modulesDone': '{done}/{total} модулей пройдено',

  // список модулей
  'ui.modules.title': 'Модули',
  'ui.modules.subtitle': 'Выбери тему для обучения',

  // учебный материал
  'ui.learning.notFound': 'Учебный материал не найден',
  'ui.learning.label': 'Учебный материал',
  'ui.learning.alisaHint': 'Прочитай материал перед прохождением теста. Здесь собрано всё самое важное!',
  'ui.learning.contents': 'Содержание',
  'ui.learning.doneTitle': 'Материал изучен!',
  'ui.learning.doneSubtitle': 'Теперь проверь свои знания в интерактивном тесте',
  'ui.learning.goToTest': 'Перейти к тесту',
  'ui.learning.startTest': 'Начать тест',

  // прохождение модуля
  'ui.module.title': 'Модуль 1: {title}',
  'ui.module.notFound': 'Модуль не найден',
  'ui.module.leaveConfirm': 'Точно хочешь выйти? Прогресс будет сохранён.',
  'ui.module.voiceOn': 'Озвучка включена',
  'ui.module.voiceOff': 'Озвучка выключена',
  'ui.module.voiceUnavailable': 'Озвучка недоступна в демоверсии',

  // результаты
  'ui.results.moduleComplete': 'Модуль «{title}» завершён',
  'ui.results.statusExcellent': 'Отлично!',
  'ui.results.statusGood': 'Хорошо!',
  'ui.results.statusFair': 'Удовлетворительно',
  'ui.results.statusMoreTraining': 'Требуется доп. обучение',
  'ui.results.recPerfect':
    'Ты отлично подготовился к первому рабочему дню! Все ответы правильные. Ты готов к работе на линии!',
  'ui.results.recDecent':
    'Неплохой результат! Обрати внимание на ошибки и попробуй ещё раз, чтобы закрепить материал.',
  'ui.results.recRetake':
    'Рекомендую пройти модуль заново. Внимательно читай каждую ситуацию и обращай внимание на подсказки.',
  'ui.results.time': 'Время',
  'ui.results.mistakes': 'Ошибок',
  'ui.results.points': 'Баллов',
  'ui.results.breakdown': 'Детализация баллов',
  'ui.results.advice': 'Рекомендация Алисы',
  'ui.results.tryAgain': 'Пройти заново',
  'ui.results.backToMenu': 'Вернуться в меню',
  'ui.results.metric.Safety': 'Безопасность',
  'ui.results.metric.Service': 'Сервис',
  'ui.results.metric.Efficiency': 'Эффективность',
  'ui.results.metric.Professionalism': 'Профессионализм',
  'ui.results.metric.StressResistance': 'Стрессоустойчивость',

  // прогресс
  'ui.progress.title': 'Прогресс',
  'ui.progress.subtitle': 'Твои достижения и история обучения',
  'ui.progress.completed': 'Пройдено',
  'ui.progress.totalPoints': 'Всего баллов',
  'ui.progress.overall': 'Общий прогресс',
  'ui.progress.history': 'История прохождений',
  'ui.progress.empty': 'Ты ещё не прошёл ни одного модуля',
  'ui.progress.unknownModule': 'Неизвестный модуль',
  'ui.progress.gradeGreat': 'Отлично',
  'ui.progress.gradeGood': 'Хорошо',
  'ui.progress.gradeRetake': 'Повторить',
  'ui.progress.pts': 'б.',

  // профиль
  'ui.profile.role': 'Курьер-стажёр',
  'ui.profile.statModules': 'Модулей',
  'ui.profile.statTime': 'Время',
  'ui.profile.statBest': 'Лучший',
  'ui.profile.logout': 'Выйти из аккаунта',
  'ui.profile.logoutConfirm': 'Точно выходишь? Весь прогресс будет удалён.',


  // ссылки наружу: сайт агентства и запись звонка
  'ui.cta.site': 'Сделано в BrilliantFlux',
  'ui.cta.booking': 'Записаться на звонок',

  // вкладка браузера
  'ui.meta.title': 'Delivery Ace | Тренажёр',
  'ui.meta.description': 'Интерактивный тренажёр для курьеров доставки',
};
